import React from 'react';
import { observer } from 'mobx-react-lite';

import { Card } from 'app/components/common/Card';
import { useModelWithArguments } from 'app/hooks/useViewModel';
import { UserLevelSelect } from 'app/components/UserLevelSelect';
import { CardProperty } from 'app/components/common/CardProperty';
import { UserProfile } from 'common/types/models/user';
import { UserViewModel } from 'app/viewModels/components/UserViewModel';

type Props = {
    userId: string,
};

export const UserCard = observer(({ userId }: Props) => {
    const {
        changePremiumLevel,
        navigateToTheInnerPage,
        user,
        name,
    } = useModelWithArguments(UserViewModel, userId);

    const convertedDate = new Date(user.created_at).toLocaleDateString('en-GB');

    return (
        <Card
            title={name || '-'}
            subtitle={UserProfile.getEmail(user)}
            onClickBtn={navigateToTheInnerPage}
            isActiveHeader
        >
            <CardProperty title="Date">
                <span className="p1-regular dark-violet">{convertedDate}</span>
            </CardProperty>
            <CardProperty title="User Type">
                <UserLevelSelect
                    currentLevel={user.premium_level}
                    onSelectLevel={changePremiumLevel}
                />
            </CardProperty>
        </Card>
    );
});
